import { COLOR_MODE } from '@ouster/webviz';

export function isReflectivityColorMode(
  coloringMode: COLOR_MODE | string | undefined | null
): boolean {
  return (
    typeof coloringMode === 'string' &&
    coloringMode.startsWith(COLOR_MODE.REFLECTIVITY)
  );
}

export function isRgbColorMode({
  coloringMode,
  rgbChannels,
}: {
  coloringMode: COLOR_MODE | string;
  rgbChannels: string[];
}): boolean {
  return rgbChannels.includes(coloringMode);
}

export function shouldDisableAutoLevelsForMode({
  coloringMode,
  colorPalette,
}: {
  coloringMode: COLOR_MODE | string;
  colorPalette: string;
  rgbChannels: string[];
}): boolean {
  return isReflectivityColorMode(coloringMode) && colorPalette === 'CalRef';
}
